import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getUserDetails } from "../services/userService";

export const fetchUserData = createAsyncThunk(
  "user/fetchUserData",
  async (userId, { rejectWithValue }) => {
    try {
      const response = await getUserDetails(userId);

      if (response.status || response.success) {
        return response.data !== undefined ? response.data : response;
      } else {
        return rejectWithValue("API returned status false");
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

const userSlice = createSlice({
  name: "user",
  initialState: {
    userId: null,
    profile: null,
    loading: false,
    error: null,
    token: null,
    fcmToken: null,
    nearbyDogs: [],
    emailSubscribed: true,
  },
  reducers: {
    setUserId: (state, action) => {
      state.userId = action.payload;
    },
    logout: (state) => {
      state.userId = null;
      state.profile = null;
      state.token = null;
      state.nearbyDogs = [];
      state.emailSubscribed = true;
      sessionStorage.clear();
      localStorage.removeItem("sp_onboarding_form");
    },
    setUserData: (state, action) => {
      state.token = action.payload.token;
      state.profile = action.payload.data;
    },
    setNearbyDogsCache: (state, action) => {
      state.nearbyDogs = action.payload;
    },
    setFcmToken: (state, action) => {
      state.fcmToken = action.payload;
    },
    updateProfileInStore: (state, action) => {
      state.profile = action.payload;
    },
    setEmailSubscription: (state, action) => {
      state.emailSubscribed = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // 1. Loading State
      .addCase(fetchUserData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      // 2. Success State (Save Data)
      .addCase(fetchUserData.fulfilled, (state, action) => {
        state.loading = false;
        state.profile = action.payload;
      })
      // 3. Error State
      .addCase(fetchUserData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  setFcmToken,
  setUserId,
  setUserData,
  logout,
  setNearbyDogsCache,
  updateProfileInStore,
  setEmailSubscription,
} = userSlice.actions;
export default userSlice.reducer;
